import { CircularProgress } from '@mui/material';
import { ComponentType } from 'react';

import { CubeChartBaseProps, CubeChartProps, CubeChartType, CubeChartTypeUnion } from './CubeChart.types';
import { CubeChartArea } from './CubeChartArea/CubeChartArea';
import { CubeChartBar } from './CubeChartBar/CubeChartBar';
import { CubeChartBarTiny } from './CubeChartBarTiny/CubeChartBarTiny';
import { CubeChartLine } from './CubeChartLine/CubeChartLine';
import { CubeChartTable } from './CubeChartTable/CubeChartTable';

const typeMap: { [key in CubeChartTypeUnion]: ComponentType<CubeChartBaseProps> | undefined } = {
  [CubeChartType.bar]: CubeChartBar,
  [CubeChartType.area]: CubeChartArea,
  [CubeChartType.line]: CubeChartLine,
  [CubeChartType.tinyBar]: CubeChartBarTiny,
  [CubeChartType.table]: CubeChartTable,
};

export const CubeChart = <TData extends Record<string, any>>({
  type,
  error,
  resultSet,
  isLoading,
  ...otherProps
}: CubeChartProps<TData>) => {
  if (error) {
    return <div>{error.toString()}</div>;
  }
  if (isLoading || !resultSet) {
    return <CircularProgress size={20} />;
  }
  const ChartComponent = typeMap[type];
  if (ChartComponent) {
    return <ChartComponent resultSet={resultSet} {...otherProps} />;
  }
  return null;
};
